<template>
  <v-layout>
    <v-flex class="scroll-y">

      <v-card color="accent" :elevation="1">
        <v-card-text class="py-3">
          <v-layout wrap row>
            <v-flex xs12 sm6 md3>
              <agricoltori-select
                :label="$t('label.cliente')"
                v-model="filters.agricoltore"
                class="input--dense"
                solo-inverted flat dark clearable/>
            </v-flex>

            <v-flex xs12 sm6 md3>
              <convenzioni-select
                :label="$t('label.convenzione')"
                v-model="filters.convenzione"
                class="input--dense"
                solo-inverted flat dark clearable/>
            </v-flex>

            <v-flex xs12 sm6 md2>
              <date-picker
                :prefix="$t('label.da') + ':'"
                v-model="filters.from"
                :locale="$i18n.locale"
                :max="filters.to"
                class="input--dense date-input"
                solo-inverted flat dark clearable/>
            </v-flex>

            <v-flex xs12 sm6 md2>
              <date-picker
                :prefix="$t('label.a') + ':'"
                v-model="filters.to"
                :locale="$i18n.locale"
                :min="filters.from"
                class="input--dense date-input"
                solo-inverted flat dark clearable/>
            </v-flex>

            <v-flex d-flex xs12 md2>
              <v-btn center dark depressed color="rgba(255,255,255,0.16)" class="ma-0 height-36"
                     @click="clearFilters()">
                {{$t('prenotazioni.azioni.rimuovi_filtri') }}
              </v-btn>
            </v-flex>

          </v-layout>
        </v-card-text>
      </v-card>

      <prenotazioni-list
        ref="prenotazioniList"
        :loading="loading"
        :prenotazioni="computedPrenotazioni"
        @change="fetchPrenotazioni"
        show-headers/>

      <div v-if="pagination.pages > 1 && !loading" class="text-xs-center mt-2">
        <v-pagination color="accent" circle v-model="pagination.selectedPage" :length="pagination.pages" total-visible="10"/>
      </div>

      <v-btn v-if="!$store.getters.isAbbonamentoExpired" @click="showCreateDialog" color="accent"
             fixed right bottom large round class="mr-2">
        <v-icon class="mr-2">add</v-icon>
        {{ $t('azioni.aggiungi') }}
      </v-btn>

    </v-flex>
  </v-layout>
</template>

<script>
import PrenotazioniList from '@/components/PrenotazioniList'
import { DatePicker, AgricoltoriSelect, ConvenzioniSelect } from '@/components/inputs/index'

export default {
    name: 'PrenotazioniAdvanced',
    components: { PrenotazioniList, DatePicker, AgricoltoriSelect, ConvenzioniSelect },
    data: () => ({
        loading: false,
        prenotazioni: [],
        filters: {
            agricoltore: null,
            convenzione: null,
            from: null,
            to: null
        },
        pagination: {
            rowsPerPage: 10,
            pages: 1,
            selectedPage: 1
        }
    }),
    watch: {
        filters: {
            handler (val) {
                this.pagination.selectedPage = 1
                this.fetchPrenotazioni(1)
            },
            immediate: true,
            deep: true
        },
        pagination: {
            handler (val) {
                this.fetchPrenotazioni(this.pagination.selectedPage)
            },
            deep: true
        }
    },
    computed: {
        computedPrenotazioni () {
            let result = []
            let lastDate = ''
            for (let pren of this.prenotazioni) {
                if (lastDate !== pren.data_controllo) {
                    lastDate = pren.data_controllo
                    result.push({ header: lastDate })
                }
                result.push(pren)
            }
            return result
        }
    },
    methods: {
        showCreateDialog () {
            this.$refs.prenotazioniList.showCreateDialog()
        },
        clearFilters () {
            for (let key in this.filters) {
                if (this.filters.hasOwnProperty(key)) {
                    this.filters[key] = null
                }
            }
        },
        fetchPrenotazioni (page) {
            this.loading = true
            this.$api.prenotazioni.get({
                ...this.filters,
                p: page,
                n: this.pagination.rowsPerPage
            }).then(response => {
                this.loading = false
                this.prenotazioni = response.data.items
                this.pagination.pages = Math.ceil(response.data.n / this.pagination.rowsPerPage)
            }).catch(e => {
                this.$snackbar.showServerError(e)
                this.loading = false
            })
        }
    }
}
</script>
<style lang="scss" scoped>
  .date-input /deep/ .v-input__control {
    color: rgba(255, 255, 255, 0.7);
  }
</style>
